import { render, staticRenderFns } from "./DocenteEditar.vue?vue&type=template&id=d7757ec8&"
import script from "./DocenteEditar.vue?vue&type=script&lang=js&"
export * from "./DocenteEditar.vue?vue&type=script&lang=js&"
import style0 from "./DocenteEditar.vue?vue&type=style&index=0&id=d7757ec8&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports